<template>
  <v-row>
    <v-col cols="10">
      <p class="float-left">Applied Filters</p>

      <span v-for="(item, key) in photoFilter" :key="key">
          <v-chip v-if="key=='fromDt' && item != null " class="ma-2">
            Tagged From Date - {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='thruDt' && item != null " class="ma-2">
            Tagged Thru Date - {{ item }}
          </v-chip>

          <v-chip v-for="filter in item" v-else-if="key=='taggers'" :key="filter.id" class="ma-2">
            {{ filter.email }}
          </v-chip>

           <v-chip v-for="tag in item" v-else-if="key=='tags'" :key="tag.id" class="ma-2">
            {{ tag.full_name }}
          </v-chip>

          <v-chip v-for="project in item" v-else-if="key=='projects'" :key="project.id" class="ma-2">
            {{ project.name }}
          </v-chip>

          <v-chip v-for="job in item" v-else-if="key=='jobs'" :key="job.id" class="ma-2">
            {{ job.name }}
          </v-chip>

          <v-chip v-else-if="key=='department' && item!=null" class="ma-2">
            Department: {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='country' && item!=null" class="ma-2">
            Country: {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='onlyNeedsReview' && item==true" class="ma-2">
            Only Needs Review
          </v-chip>

        <v-chip v-else-if="key=='retailer' && item!=null" class="ma-2">
            Retailer: {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='showQCed' && item==true" class="ma-2">
            Show QCed
          </v-chip>

          <v-chip v-else-if="key=='includeInactive' && item==true" class="ma-2">
            Include Inactive Photos
          </v-chip>

          <v-chip v-else-if="key=='rgidSearchFreeForm' && item" class="ma-2">
            Response Group ID: {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='respIdSearchFreeForm' && item" class="ma-2">
            Response ID: {{ item }}
          </v-chip>

          <v-chip v-else-if="key=='question_id' && item" class="ma-2">
            Question ID: {{ item }}
          </v-chip>

        </span>

    </v-col>
    <v-col cols="2">
      <v-row>
        <v-col cols="3">
          <filter-btn :dialog="dialog" class="mr-0">
            <group-q-c-filter-modal
                                    :photoFilters="photoFilter"
                                    :retailerChoices="retailers"
                                    :departmentChoices="departments"
                                    @apply-filters="applyFilters($event)"
                                    @dialog-clicked="handleDialogClicked($event)"
                                    @modal-mounted="dialog = true"
            />
          </filter-btn>
        </v-col>
        <v-col cols="9">
          <v-btn class="mr-0" color="primary" small @click="resetFilters">
            Reset Filters
          </v-btn>
        </v-col>
      </v-row>

    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import FilterBtn from '../btns/FilterBtn.vue'
import GroupQCFilterModal from './GroupQCFilterModal.vue'
import {mapState} from 'vuex'


export default {
  name: 'GroupQCFilter',
  components: {
    GroupQCFilterModal,
    FilterBtn
  },
  props: {
    initialFilter: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      retailers: [],
      departments: [],
      photoFilter: {
        fromDt: null,
        thruDt: null,
        tags: [],
        taggers: [],
        // IT-707 P2.4: apply_group_filters has read all four since IT-528, and
        // GroupCountQC already sends them through the SAME endpoint. This
        // surface just never collected them.
        projects: [],
        jobs: [],
        department: null,
        country: null,
        onlyNeedsReview: false,
        showQCed: false,
        includeInactive: false,
        retailer: null,
        rgidSearchFreeForm: null,
        respIdSearchFreeForm: null,
        question_id: null
      }
    }
  },
  mounted() {
    this.get_retailer_list()
    this.get_department_list()
    this.photoFilter.fromDt = this.initialFilter.fromDt
    this.photoFilter.thruDt = this.initialFilter.thruDt
    this.photoFilter.tags = this.initialFilter.tags
    this.photoFilter.taggers = this.initialFilter.taggers
    this.photoFilter.projects = this.initialFilter.projects
    this.photoFilter.jobs = this.initialFilter.jobs
    this.photoFilter.department = this.initialFilter.department
    this.photoFilter.country = this.initialFilter.country
    this.photoFilter.onlyNeedsReview = this.initialFilter.onlyNeedsReview
    this.photoFilter.showQCed = this.initialFilter.showQCed
    this.photoFilter.includeInactive = this.initialFilter.includeInactive === true
    this.photoFilter.retailer = this.initialFilter.retailer
    this.photoFilter.rgidSearchFreeForm = this.initialFilter.rgidSearchFreeForm
    this.photoFilter.respIdSearchFreeForm = this.initialFilter.respIdSearchFreeForm
    this.photoFilter.question_id = this.initialFilter.question_id
  },
  computed: {
    ...mapState({
      tags: state => state.tags.tags,
    })
  },
  watch: {},
  methods: {
    async get_retailer_list() {
      this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
        fields: [{'keys': ['loading_list'], 'value': 'get_retailer_list', action: 'toggle'},]
      });

      let new_this = this;
      return new Promise((resolve, reject) => {
        axios.get('/api/retailers').then(response => {
          let data = response.data;
          new_this.retailers = data;
          resolve(response.data);
        }).catch(e => {
          console.log(e);
          reject(e);
        }).finally(() => {
          new_this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
            fields: [{'keys': ['loading_list'], 'value': 'get_retailer_list', action: 'toggle'},]
          });
        });
      });
    },
    async get_department_list() {
      this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
        fields: [{'keys': ['loading_list'], 'value': 'get_department_list', action: 'toggle'},]
      });

      let new_this = this;
      return new Promise((resolve, reject) => {
        axios.get('/api/departments').then(response => {
          new_this.departments = response.data;
          resolve(response.data);
        }).catch(e => {
          console.log(e);
          reject(e);
        }).finally(() => {
          new_this.$store.commit('UPDATE_STORE_ARRAY_DATA', {
            fields: [{'keys': ['loading_list'], 'value': 'get_department_list', action: 'toggle'},]
          });
        });
      });
    },
    handleDialogClicked(val) {
      this.dialog = false
    },
    applyFilters(filterValues) {

      if (filterValues.fromDt != null) {
        this.photoFilter.fromDt = filterValues.fromDt
      } else {
        this.photoFilter.fromDt = null
      }

      if (filterValues.thruDt != null) {
        this.photoFilter.thruDt = filterValues.thruDt
      } else {
        this.photoFilter.thruDt = null
      }

      if (filterValues.tags) {
        this.photoFilter.tags = filterValues.tags
      } else {
        this.photoFilter.tags = []
      }

      if (filterValues.taggers) {
        this.photoFilter.taggers = filterValues.taggers
      } else {
        this.photoFilter.taggers = []
      }

      if (filterValues.projects) {
        this.photoFilter.projects = filterValues.projects
      } else {
        this.photoFilter.projects = []
      }

      if (filterValues.jobs) {
        this.photoFilter.jobs = filterValues.jobs
      } else {
        this.photoFilter.jobs = []
      }

      this.photoFilter.department = filterValues.department
      this.photoFilter.country = filterValues.country

      this.photoFilter.onlyNeedsReview = filterValues.onlyNeedsReview
      this.photoFilter.showQCed = filterValues.showQCed
      this.photoFilter.includeInactive = filterValues.includeInactive === true
      this.photoFilter.retailer = filterValues.retailer
      this.photoFilter.rgidSearchFreeForm = filterValues.rgidSearchFreeForm
      this.photoFilter.respIdSearchFreeForm = filterValues.respIdSearchFreeForm
      this.photoFilter.question_id = filterValues.question_id

      this.dialog = false
      this.$emit('apply-filters', this.photoFilter)
    },
    resetFilters() {
      this.photoFilter.fromDt = null
      this.photoFilter.thruDt = null
      this.photoFilter.tags = []
      this.photoFilter.taggers = []
      this.photoFilter.projects = []
      this.photoFilter.jobs = []
      this.photoFilter.department = null
      this.photoFilter.country = null
      this.photoFilter.onlyNeedsReview = false
      this.photoFilter.showQCed = false
      this.photoFilter.includeInactive = false
      this.photoFilter.retailer = null
      this.photoFilter.rgidSearchFreeForm = null
      this.photoFilter.respIdSearchFreeForm = null
      this.photoFilter.question_id = null
      this.$emit('apply-filters', this.photoFilter)
    },

  }
}
</script>

<style>
</style>
